import React from 'react';
import PropTypes from 'prop-types';
import radius from 'venuescanner-js/constants/search_radius';
import SelectField from './SelectField';

const RadiusField = React.forwardRef(
  (
    { clearButton = true, containerClassName, onChange, value = 0, ...props },
    ref,
  ) => {
    const queryRadius = (value || 0).toString();
    let selectValue = radius.find(rad => rad.value === queryRadius);
    if (!selectValue) selectValue = radius.find(rad => rad.value === '0');

    return (
      <div>
        <SelectField
          containerClassName={containerClassName}
          placeholder='Search by miles'
          ref={ref}
          options={radius}
          clearButton={clearButton}
          onChange={onChange}
          value={selectValue}
          isSearchable={false}
          {...props}></SelectField>
      </div>
    );
  },
);
RadiusField.displayName = 'RadiusField';

RadiusField.propTypes = {
  clearButton: PropTypes.bool,
  value: PropTypes.number,
  containerClassName: PropTypes.string,
  onChange: PropTypes.func
};

export default RadiusField;
